import React, { useState, useEffect, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import NavigationMenu from './Components/NavigationMenu';
import './Components/style.css';
import { jwtDecode } from 'jwt-decode';
import { Analytics } from '@vercel/analytics/react';
import CookieConsent from './Components/CookieConsent';

// Code splitting / Lazy load secondary routes for fast initial paint
const Contact = lazy(() => import('./Components/Contact'));
const Notice = lazy(() => import('./Components/Notice'));
const Books = lazy(() => import('./Components/Books'));
const Gallery = lazy(() => import('./Components/Gallery'));
const Videos = lazy(() => import('./Components/Videos'));
const Quiz = lazy(() => import('./Components/Quiz'));
const Admin = lazy(() => import('./Components/Admin'));
const PrivacyPolicy = lazy(() => import('./Components/PrivacyPolicy'));

const ThemeStored = () => {
  const storedTheme = localStorage.getItem('Theme');
  return storedTheme ? JSON.parse(storedTheme) : 'light-theme';
};

function App() {

  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
      }
    }
  };

  checkTokenExpiration();

  const [Theme, setTheme] = useState(() => ThemeStored());

  useEffect(() => {
    const handleThemeChange = () => {
      const storedTheme = localStorage.getItem('Theme');
      if (storedTheme) {
        setTheme(JSON.parse(storedTheme));
      }
    };
    window.addEventListener('themeChanged', handleThemeChange);
    return () => window.removeEventListener('themeChanged', handleThemeChange);
  }, []);

  useEffect(() => {
    localStorage.setItem('Theme', JSON.stringify(Theme));
  }, [Theme]);

  return (
    <div className={`App ${Theme}`}>
      <Router>
        <div className="app-layout">
          <NavigationMenu />
          <main className="main-content">
            <Analytics />
            <Suspense fallback={
              <div className="d-flex align-items-center justify-content-center min-vh-100">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            }>
              <Routes>
                <Route path='/' exact element={<Home />} />
                <Route path='/Contact' element={<Contact />} />
                <Route path='/Notice' element={<Notice />} />
                <Route path='/Books' element={<Books />} />
                <Route path='/Gallery' element={<Gallery />} />
                <Route path='/Videos' element={<Videos />} />
                <Route path='/Quiz' element={<Quiz />} />
                <Route path='/Admin' element={<Admin />} />
                <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
              </Routes>
            </Suspense>
          </main>
          <CookieConsent />
        </div>
      </Router>
    </div>
  );
}

export default App;
